export default __webpack_public_path__ + "static/media/vlablogo2.00a678a6.jpg";